import { ContentCopy } from '@mui/icons-material'
import { Box, Button, TextField } from '@mui/material'
import React from 'react'
import { useGlobalSnackbarStore } from '../../../store/GlobalSnackBarStore'
import { blue } from '../../theme'

interface Props {
  /** Holds the checkout token, which is a secret: display and copy only, never log it. */
  checkoutUrl: string
}

export const GuestCheckoutLink: React.FC<Props> = ({ checkoutUrl }) => {
  const globalSnackBarStore = useGlobalSnackbarStore()

  const copyLink = () => {
    navigator.clipboard.writeText(checkoutUrl)
    globalSnackBarStore.triggerSuccessMessage('Lien de paiement copié dans le presse-papier.')
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { sm: 'center' }, gap: 1 }}>
      <TextField
        label="Lien de paiement"
        value={checkoutUrl}
        fullWidth
        size="small"
        inputProps={{ readOnly: true }}
        InputLabelProps={{ shrink: true }}
        onFocus={(event) => event.target.select()}
      />
      <Button
        variant="outlined"
        startIcon={<ContentCopy />}
        onClick={copyLink}
        // Explicitly blue: the theme's primary is the amber used for main actions, and copying the
        // link is a secondary one next to it.
        sx={{
          textTransform: 'none',
          flexShrink: 0,
          color: blue,
          borderColor: blue,
          backgroundColor: 'white',
          '&:hover': { borderColor: blue, backgroundColor: 'rgba(32, 56, 100, 0.04)' },
        }}
      >
        Copier le lien
      </Button>
    </Box>
  )
}
